module.exports = __webpack_public_path__ + "static/media/179947B.545c95b8.jpg";